import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { PartidaAclaracionGuiaEdit } from "./edit";
import { PartidaAclaracionGuia, PartidaAclaracionDTO, CondicionEntrega, CondicionPago, DescripcionConcepto } from "app/models/requireme";
import { TotalConceptoList } from "../totales";
const EditModal = PartidaAclaracionGuiaEdit;
type Entity = models.PartidaAclaracionDepositoDTO;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void> | void;
    readonly?: boolean;
}

/**Obtiene las columnas del grid */
function columnas(deps: kea.BotonesListaDeps<Entity>): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [
        botones,
        { title: "Deposito", cell: x => ({ data: x.SerieFolio }) },
        { title: "Observaciones", cell: x => ({ data: x.Observaciones }) },
        { title: "Condición", cell: x => ({ data: x.CondicionNombre }) },
        { title: "Descripción", cell: x => ({ data: x.DescripcionNombre }) },
        { title: "Total", cell: x => ({ data: x.Total }) },
    ];
}

/**
* Listado de depositos ligados a una partida de aclaracion
*/
class PartidasAclaracionDepositosListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    private async setValue(val: models.PartidaAclaracionDeposito): Promise<models.PartidaAclaracionDepositoDTO> {
        const dep = await resources.DepositoBanco.Get(val.IdDeposito);
        return { ...val, SerieFolio: dep.SerieFolio, 
        CondicionNombre: val.Condicion == CondicionPago.Pagada ? "Pagada" : "Pendiente",
        DescripcionNombre: val.DescripcionConcepto == DescripcionConcepto.Devolucion ? "Devolución" : "Reexpedicion",
        Total: dep.ImporteDeposito };
    }

    private handleOnAgregar = async () => {
        const result = await this.modals.showModal(EditModal, undefined, {} as Entity);;
        if (result.result) {
            const newItem = await this.setValue(result.value);
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }

    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {
            const newItem = await this.setValue(result.value);
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.SerieFolio);
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    totales = async () => {
        const ret = await resources.PartidasAclaracion.GetTotalesDeposito(this.props.value);
        return ret;
    }

    render() {
        const total = this.totales();
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar });
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            <span>Depositos asignados</span>
                            <div className="pull-right">
                                <kea.AgregarButton onClick={this.handleOnAgregar} disabled={this.props.readonly} />
                            </div>
                        </h4>
                    </div>
                </div>
                <TotalConceptoList value={total} color="warning"/>
                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const PartidasAclaracionDepositosList = kea.mapProps(componentToRx(PartidasAclaracionDepositosListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/partidasaclaracion/edit/depositos/list.tsx